// @/shared/components/FeatureSlot/slotIds.ts

/**
 * Registry of all FeatureSlot IDs used across the application.
 * Each slotId identifies a specific rendering position within a form step.
 */
export const FeatureSlotIds = {
    /** Above billing frequency selector in the billing step */
    MEMBERSHIP: "membership",
    /** Above Stripe payment fields in the billing step */
    PAYMENT: "payment"
} as const;

export type FeatureSlotId = (typeof FeatureSlotIds)[keyof typeof FeatureSlotIds];
